import { CASE_TYPE_OPTIONS } from '@iculogbook/shared';
import { useState } from 'react';
import { useNavigate } from 'react-router';

import { Button } from '../components/index.ts';

/**
 * What the log action opens: Procedure, Case, Communication or EDT/Teaching,
 * and if Case, which kind.
 *
 * Choosing the case type here rather than as the first field of the case form
 * costs the same tap either way, and the form then opens shorter — which is
 * what matters on a phone. The type is still editable at the top of the form.
 *
 * EDT deliberately has **no** equivalent step. There are eleven activities
 * rather than three, a screen of eleven full-width buttons is not a menu
 * anyone reads, and the EDT form's own activity chips are already the first
 * thing on it — so this goes straight there and costs the same single tap.
 */
export function LogRoute() {
  const navigate = useNavigate();
  const [choosingCaseType, setChoosingCaseType] = useState(false);

  if (choosingCaseType) {
    return (
      <div className="flex flex-col gap-3">
        <h2 className="text-sm font-medium text-muted">What kind of case?</h2>

        {CASE_TYPE_OPTIONS.map((option) => (
          <Button
            key={option.key}
            variant="secondary"
            block
            className="h-16 text-lg"
            onClick={() => void navigate(`/log/case?type=${option.key}`)}
          >
            {option.label}
          </Button>
        ))}

        <Button variant="ghost" onClick={() => setChoosingCaseType(false)}>
          Back
        </Button>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3">
      <h2 className="text-sm font-medium text-muted">What are you logging?</h2>

      <Button
        variant="primary"
        block
        className="h-20 text-lg"
        onClick={() => void navigate('/log/procedure')}
      >
        Procedure
      </Button>

      <Button
        variant="secondary"
        block
        className="h-20 text-lg"
        onClick={() => setChoosingCaseType(true)}
      >
        Case
      </Button>

      <Button
        variant="secondary"
        block
        className="h-20 text-lg"
        onClick={() => void navigate('/log/edt')}
      >
        EDT / Teaching
      </Button>

      <Button
        variant="secondary"
        block
        className="h-20 text-lg"
        onClick={() => void navigate('/log/communication')}
      >
        Communication
      </Button>

      <p className="px-1 text-xs text-faint">
        A case is an admission, a ward review or remote advice. Procedures done during a case are
        added inside it, so the date and age band are only entered once. EDT is what you did with
        your Educational Development Time — teaching, a clinic, reading, a project or an audit.
        Communication is a significant discussion — most often withdrawal or withholding of
        treatment.
      </p>
    </div>
  );
}
